import { useEffect } from 'react'
import { jwtDecode } from 'jwt-decode'
import { PUBLIC_TOKEN_KEY } from './constants.js'

function pruneExpiredToken() {
  const token = localStorage.getItem(PUBLIC_TOKEN_KEY)
  if (!token) {
    return
  }

  try {
    const { exp } = jwtDecode(token)
    const now = Math.floor(Date.now() / 1000)

    if (!exp || exp < now) {
      localStorage.removeItem(PUBLIC_TOKEN_KEY)
    }
  } catch {
    localStorage.removeItem(PUBLIC_TOKEN_KEY)
  }
}

export default function PublicTokenPruner() {
  useEffect(() => {
    pruneExpiredToken()
  }, [])

  return null
}
